import {Component, Input, OnInit} from '@angular/core';
import {Studium} from '../model/studium';
import {AppService} from '../app.service';
import {Router} from '@angular/router';

@Component({
    selector: 'app-studium-item',
    templateUrl: './studium-item.component.html',
    styleUrls: ['./studium-item.component.css'],
    standalone: false
})
export class StudiumItemComponent implements OnInit {

  @Input() data: Studium;
  show = true;
  red = false;
  title: string;

  constructor(private appService: AppService, private router: Router) { }

  ngOnInit() {
    this.red = this.appService.getRed();

    this.title = this.getTitle(this.data);
  }

  getTitle(s: Studium) {
    if (s === null || s.zapisneListy === null || s.zapisneListy.length === 0 || s.zapisneListy[0] === null) {
      return s.studijnyProgram.skratka + ' - ' + s.studijnyProgram.popis;
    }
    return s.zapisneListy[0].rocnik + s.studijnyProgram.skratka + s.kruzok
      + ' - ' + s.studijnyProgram.popis + ' (' + s.zapisneListy[0].akademickyRok + ')';
  }

  headerClick() {
    this.show = !this.show;
  }

    openMobilityApp() {
        this.appService.openPortalAppWindow('ais.gui.vs.es.VSES262_MobilityDlg', this.data.id);
    }

    openSkolnePoplatkyApp() {
        this.appService.openPortalAppWindow('ais.gui.lz.poplatky.LZ040_ZoznamPoplatkovOsobyDlg', this.data.id);
    }

    openStipendiaApp() {
        this.appService.openPortalAppWindow('ais.gui.vs.es.VSES203_DoplnujuceInformacieDlg', this.data.id);
    }

    openUdelovanieSuhlasovApp() {
        this.appService.openPortalAppWindow('ais.gui.lz.LZ063_UdelovanieSuhlasovDlg', this.data.id);
    }

    openKomplexnaKontrolaApp() {
        this.appService.openPortalAppWindow('ais.gui.vs.es.kontroly.VSES330_KomplexnaKontrolaStudiaDlg', this.data.id);
    }

    openPovinnePredmetyApp() {
        this.appService.openPortalAppWindow('ais.gui.vs.es.VSES133_StudijneKontrolaPovinnychPredmetovDlg', this.data.id);
    }

    openNeuspesneZapisyApp() {
        this.appService.openPortalAppWindow('ais.gui.vs.es.VSES132_StudijneKontrolaPoctuZapisovPredmetovDlg', this.data.id);
    }

    openAbsolvovaniePredmetovApp() {
        this.appService.openPortalAppWindow('ais.gui.vs.es.VSES157_StudijneKontrolaAbsolvovanychPredmetovDlg', this.data.id);
    }

    openZiskaneKredityApp() {
        this.appService.openPortalAppWindow('ais.gui.vs.es.studijne.VSES127_StudijnePrehladKreditovStudentaDlg', this.data.id);
    }

    openPredpisanaSkladbaApp() {
        this.appService.openPortalAppWindow('ais.gui.vs.es.kontroly.VSES331_SplneniePredpisanejSkladbyDlg', this.data.id);
    }
}
